import { FormControl, Select, MenuItem, Grid, Autocomplete, TextField, Checkbox } from "@mui/material";
import { Bar } from "react-chartjs-2";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import OutlinedInput from '@mui/material/OutlinedInput';
import ClearIcon from '@mui/icons-material/Clear';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useSelector } from "react-redux";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useState, useEffect } from "react";


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
ChartJS.register(ChartDataLabels);

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
function OverAllCostByScenarioChart(props) {
  //console.log("Over All cost-------------------------------", props.overAllCostData)
  console.log(props, "props from overall");


  const selectedCategoryId = useSelector(
    (state) => state.InputDataReducers.selectedCategoryId
  );

  const options = {
    plugins: {
      scales: {
        xAxes: [
          {
            barThickness: 6, // number (pixels) or 'flex'
            maxBarThickness: 100, // number (pixels)
          },
        ],
      },
      datalabels: {
        anchor: "end",
        align: "top",
        // color: "black",
        offset: -3,
        font: {
          weight: "bold",
          size: 12,
        },
        // formatter: Math.round,
        formatter: (value, context) => {
          const datasetArray = [];
          let total;
          function totalSum(total, datapoint) {
            return total + datapoint;
          }
          context.chart.data.datasets.forEach((dataset) => {
            if (dataset.data[context.dataIndex] !== undefined) {
              datasetArray.push(dataset.data[context.dataIndex]);
            }
          });
          total = datasetArray.reduce(totalSum, 0);
          if (context.datasetIndex === datasetArray.length - 1) {
            // return NumberFormater(total) + ' Cr';
            return "";
          } else {
            return "";
          }
        },
      },
      title: {
        display: false,
      },
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            var label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += context.parsed.y.toFixed(2);
            }
            return label;
          },
        },
      },
      // tooltip:
      // {
      //     callbacks: {
      //         title: function(item){return item},
      //         label: function (tooltipItem) { console.log('ToolTip',tooltipItem);
      //             return tooltipItem + 'cr';},
      //     }
      // }
      // ,
      // tooltip: {
      //     callbacks: {
      //         title: function (e) {
      //             return ``;
      //         },
      //         label: function (tooltipItem) {
      //             let cost = datasets[tooltipItem.datasetIndex].data[0];
      //             let displayLabel = datasets[tooltipItem.datasetIndex].label + ': ';
      //             //return `${NumberFormater(cost)} Cr \n ${displayLabel}`;
      //             return `${displayLabel}${NumberFormater(cost)} Cr }`;
      //         }
      //     }
      // }
    },
    responsive: true,
    scales: {
      x: {
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: "S C E N A R I O",
        },
        barThickness: 8,
        barPercentage: 0.5,
        stacked: true,
        scaleLabel: {
          display: true,
          labelString: "probability",
        },
      },
      y: {
        // beginAtZero: true,
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: "Cost (in Crore)",
        },
        ticks: {
          callback: function (value, index, ticks) {
            return value.toFixed(2);
          },
        },

        stacked: true,
      },
    },
  };

    // const labels = ['Baseline', 'Scenario 1'];
    
    const [labels, setLabels] = useState([])
  useEffect(() => {
    if (props.overAllCostData.length > 0) {
        const finalLabels = [];
        props.overAllCostData?.map((data) => {
            finalLabels.push(data?.chartname)
        });
        setLabels(finalLabels)
    }
  }, [props.overAllCostData])
  
  
  const temp1 = 5;
  const temp2 = 9;
  // const datasets = [
  //     {
  //         label: 'Outbound Production Cost',
  //         data: props.overAllCostData && props.overAllCostData.map((item) => item["Conversion Cost"]),
  //         backgroundColor: '#001f82'
  //     },
  //     {
  //         label: 'Inbound Transportation Cost',
  //         data: props.overAllCostData && props.overAllCostData.map((item) => item["Landed Cost"]),
  //         backgroundColor: '#00aaf4'
  //     },
  //     {
  //         label: 'Procurement Cost',
  //         data: props.overAllCostData && props.overAllCostData.map((item) => item["Pri Transportation Cost"]),
  //         backgroundColor: '#9c44c0'
  //     }
  // ];

  var datasets = [];

  const homeDatasets = [
    // Outbound Production cost
    {
      label: "Landed Cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map((item) => item["Landed Cost"]),
      backgroundColor: "#FF9998",
    },
    //Inbound Transportation Cost
    {
      label: "Conversion Cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map((item) => item["Conversion Cost"]),
      backgroundColor: "#FFEC9A",
    },
    //Procurement cost
    {
      label: "Pri Transportation Cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map((item) => item["Pri Transportation Cost"]),
      backgroundColor: "#FFC000",
    },
    // Production cost
    // {
    //   label: "Conversion Cost",
    //   data:
    //     props.overAllCostData &&
    //     props.overAllCostData.map((item) => item["Conversion Cost"]),
    //   backgroundColor: "#00B190",
    // },
    // //fixed cost
    // {
    //   label: "Fixed Cost",
    //   data:
    //     props.overAllCostData &&
    //     props.overAllCostData.map((item) => item["Pri Transportation Cost"]),
    //   backgroundColor: "#A3E1D2",
    // },
  ];

  const nutritiondatasets = [
    {
      label: "RMPM landed cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map((item) => item["RMPM landed cost"]),
      backgroundColor: "#A3E1D2",
    },
    {
      label: "Processing cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map((item) => item["Processing cost"]),
      backgroundColor: "#00B190",
    },
    {
      label: "SFG transportation cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map((item) => item["SFG transportation cost"]),
      backgroundColor: "#FFC000",
    },
    {
      label: "Packaging cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map((item) => item["Packaging cost"]),
      backgroundColor: "#FFEC9A",
    },
    {
      label: "Primary Transportation cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map(
          (item) => item["Primary Transportation cost"]
        ),
      backgroundColor: "#FF9998",
    },
  ];

  if (selectedCategoryId === 1) {
    datasets = homeDatasets;
  } else {
    datasets = nutritiondatasets;
  }

  console.log("Result data --Over All:", datasets);

  const [selectedScenarios, setSelectedScenarios] = useState([])
  const handleChangeSelectScenario1 = (event, newSelected) => {
    if (newSelected.length > 0) {

    setSelectedScenarios((prevSelected) => {
        const updatedSelected = [...prevSelected];
        const scenario = newSelected[newSelected.length - 1];
    
        if (updatedSelected.some((item) => item?.scenario === scenario?.scenario)) {
          // Scenario is already selected, so deselect it
          const indexToRemove = updatedSelected.findIndex(
            (item) => item?.scenario === scenario?.scenario
          );
          updatedSelected.splice(indexToRemove, 1);
        } else {
          // Scenario is not selected, so add it
          updatedSelected.push(scenario);
        }
    
        return updatedSelected;
      });
      console.log(selectedScenarios, newSelected, "newSelected");
    // loadCharts(selectedInnerFolderId,newValue,selectScenario2Id);
    }else {
      setSelectedScenarios([])
    }
  }

  const scenarioOptions = [
    {
        "scenario_id": 0,
        "folder_id": 347,
        "scenario": "Landed Cost",
        "filetype": 1,
        "scenario_time": null,
        "number": 1476
    },
    {
        "scenario_id": 1477,
        "folder_id": 347,
        "scenario": "Conversion Cost",
        "filetype": 2,
        "scenario_time": "",
        "number": 1477
    },
    {
        "scenario_id": 1480,
        "folder_id": 347,
        "scenario": "Pri Transportation Cost",
        "filetype": 2,
        "scenario_time": null,
        "number": 1480
    },
  
]

const nutritionScenarioOptions = [
    {
        "scenario_id": 0,
        "folder_id": 347,
        "scenario": "RMPM landed cost",
        "filetype": 1,
        "scenario_time": null,
        "number": 1476
    },
    {
        "scenario_id": 1477,
        "folder_id": 347,
        "scenario": "Processing Cost",
        "filetype": 2,
        "scenario_time": "",
        "number": 1477
    },
    {
        "scenario_id": 1480,
        "folder_id": 347,
        "scenario": "SFG transportation cost",
        "filetype": 2,
        "scenario_time": null,
        "number": 1480
    },
    {
        "scenario_id": 1480,
        "folder_id": 347,
        "scenario": "packaging cost",
        "filetype": 2,
        "scenario_time": null,
        "number": 1480
    },
    {
        "scenario_id": 1480,
        "folder_id": 347,
        "scenario": "Primary Transportation cost",
        "filetype": 2,
        "scenario_time": null,
        "number": 1480
    }
  ]
  
  let sr = localStorage.getItem('selectedRadio')
  console.log(sr, "srcccccc")
const scenarioNames = sr === "masterData" ? scenarioOptions.map(item => item.scenario): nutritionScenarioOptions.map(item => item.scenario);
  
const [selectedScenario, setSelectedScenario] = useState([]);
console.log(selectedScenario, "seseesesee")

const handleScenarioChange = (event) => {
  setSelectedScenario(event.target.value);
};
const handleClear = () => {
setSelectedScenario([]);
};

console.log("Result data --Over All:", datasets);

  const filterArray = [];
  if (selectedScenarios) {
    selectedScenarios?.map((item) => {
      filterArray.push(item?.scenario);
    });
  }
 

  if (selectedScenario?.length > 0) {
    const maxDataLength = Math.max(...datasets.map((item) => item?.data.length));

    datasets?.forEach((item) => {
      let isMatched = false;
      for (const filterString of selectedScenario) {
        if (item?.label?.toLowerCase().includes(filterString?.toLowerCase())) {
          isMatched = true;
          break;
        }
      }
      if (!isMatched) {
        item.data = Array(maxDataLength).fill(0);
      }
    });
    }
    console.log(datasets, "filterArray");

  const baselineData = {
    // labels: props.data
    //   .sort((a, b) => (a.visit > b.visit ? 1 : -1))
    //   .map((item) => `Week ${item.visit}`),
    labels: labels,
    datasets,
  };

  const options01 = {
    plugins: {
      categoryPercentage: 0.4,
      barPercentage: 0.5,
      datalabels: {
        display: true,
        color: "black",
        // formatter: Math.round,
        formatter: (value, context) => {
          const datasetArray = [];
          let total;
          function totalSum(total, datapoint) {
            return total + datapoint;
          }
          context.chart.data.datasets.forEach((dataset) => {
            if (dataset.data[context.dataIndex] !== undefined) {
              datasetArray.push(dataset.data[context.dataIndex]);
            }
          });
          total = datasetArray.reduce(totalSum, 0);
          if (context.datasetIndex === datasetArray.length - 1) {
            // return NumberFormater(total) + ' Cr';
            return "";
          } else {
            return "";
          }
        },
        anchor: "end",
        offset: -20,
        align: "start",
      },
      title: {
        display: false,
        // text: 'Chart.js Bar Chart - Stacked',
      },
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: function (item) {
            return item.title;
          },
          label: function (tooltipItem) {
            console.log("ToolTip", tooltipItem);
            //return tooltipItem.dataset.label + ': ' + tooltipItem.formattedValue + ' cr';},
            return (
              tooltipItem.dataset.cost +
              ":" +
              tooltipItem.dataset.label +
              " : " +
              tooltipItem.formattedValue
            );
          },
        },
      },
      // tooltip: {
      //     callbacks: {
      //         title: function (e) {
      //             return ``;
      //         },
      //         label: function (tooltipItem) {
      //             let cost = datasets[tooltipItem.datasetIndex].data[0];
      //             let displayLabel = datasets[tooltipItem.datasetIndex].label + ': ';
      //             //return `${NumberFormater(cost)} Cr \n ${displayLabel}`;
      //             return `${displayLabel}${NumberFormater(cost)} Cr `;
      //         }
      //     }
      // }
    },
    responsive: true,
    barPercentage: 0.5,
    scales: {
      x: {
        maxBarThickness: 100,
        categoryPercentage: 0.4,
        barPercentage: 0.5,
        grid: {
          display: false,
          //drawBorder: false
        },
        title: {
          display: true,
          text: "T I M E  P E R I O D",
        },
        barThickness: 10, // number (pixels) or 'flex'
        // barPercentage: 10,
        stacked: true,
        scaleLabel: {
          display: true,
          labelString: "probability",
        },
      },
      y: {
        categoryPercentage: 10,
        grid: {
          display: false,
          //drawBorder: false
        },
        title: {
          display: true,
          text: "Cost (in Crore)",
        },
        ticks: {
          callback: function (value, index, ticks) {
            return value.toFixed(2);
          },
        },
        stacked: true,
      },
    },
  };

  

  const [shortTermStatus, setShortTermStatus] = useState(false);
  const labelTimePeriod = props.timPeriodOverAllCost.label;
  const data01 = {
    labels: labelTimePeriod,
    datasets: props.timPeriodOverAllCost.data,
  };


const data = baselineData?.datasets;
const sums = Array(data[0].data.length).fill(0);

data.forEach(item => {
  item.data.forEach((value, index) => {
    if (value !== null && value !== undefined) {
      sums[index] += value;
    }
  });
});

  console.log(sums, "sm");



  console.log(options, labels, "overall");
  const selectedFolderData = useSelector(
    (state) => state.InputDataReducers.selectedFolderData
  );
  useEffect(() => {
    setSelectedScenario([]);
 }, [selectedFolderData])
  return (
    <>
      <div className="chart-block">
        <div className="chart-container">
          <div className="dropdown_container">
          <div className="pull-left">
          {" "}
          <h2>Overall Cost by Scenario (in Crore)</h2>
        </div>
     
  
       
  
    <div className="clear"></div>
          </div>

          <div className="pull-right">
          <FormControl sx={{width: 300 }}>
          <InputLabel id="demo-multiple-checkbox-label">Filter By Cost</InputLabel>
          <Select
            id="scenario-multi-select"
            multiple
            value={selectedScenario}
            onChange={handleScenarioChange}
            input={
              <OutlinedInput
                label="Select Scenarios"
                endAdornment={
                  selectedScenario.length > 0 && (
                    <ClearIcon
                      style={{ cursor: 'pointer' }}
                      onClick={handleClear}
                    />
                  )
                }
              />
            }
            renderValue={(selected) => selected.join(', ')}
           
          >
            {scenarioNames.map((scenario) => (
              <MenuItem key={scenario} value={scenario}>
                <Checkbox checked={selectedScenario.indexOf(scenario) > -1} />
                <ListItemText primary={scenario} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
          </div>
          <div class="clear"></div>
          <br />
          <div className="sum_container">
          {sums.map((item) => (
              <div>{item !==0 ? <div className="sum_container_items">{item.toFixed(2)}</div> : ""}</div>
       ))}
      </div>
          <Bar
            id="overall-cost-by-scenario"
            options={options}
            data={baselineData}
            height="100"
          />
        </div>
        
      </div>
      {/* <div className="chart-block">
                <div className="chart-container">
                    <div className="pull-left"> <h2>Overall Cost by Scenario</h2></div>
                    <div className="pull-right">
                        filters
                    </div>
                    <div className="clear"></div>
                    <br />
                    <Bar id="overall-cost-by-scenario" options={options} data={baselineData} height='100' />
                </div>
            </div>
            {/* <div className="chart-block">
                <div className="chart-container">
                    <h2>Cost comparision split by time</h2>
                    <br />
                    <Bar id="cost-comparision-split-by-time" data={data01} options={options01} height="200" />
                </div>
            </div> */}
    </>
  );
}

export default OverAllCostByScenarioChart;
